<template>
    <div>
        <b-row>
            <b-col md="3">
                <b-form-group label="Cedente">
                    <input-cedente required :mostrarInativo="false"
                      ref="inputCedente"
                      v-model="model.codigoCedente"
                      @input="loadComboCedentesCarteiras"
                      :disabled="pesquisaCodBarras"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Cedente/Carteira">
                    <input-select v-model="model.codigoCedenteCarteira"
                                  :options="cedentesCarteiras"
                                  required
                                  :disabled="pesquisaCodBarras" />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Documento Federal Pagador">
                    <b-input v-model="model.documentoPagador"
                             v-mask="documentMask"
                             :disabled="pesquisaCodBarras" />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Nome Pagador">
                    <b-input v-model="model.nomePagador" :disabled="pesquisaCodBarras"></b-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="3">
                <b-form-group label="Data Registro">
                    <input-date v-model="model.dtRegistro" :max="new Date()" :disabled="pesquisaCodBarras"></input-date>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group label="Data Vencimento">
                    <input-date v-model="model.dtVencimento" :disabled="pesquisaCodBarras"></input-date>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Seu Número">
                    <b-input v-model="model.seuNumero" :maxlength="15" :disabled="pesquisaCodBarras"></b-input>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Nosso Número">
                    <b-input v-model="model.nossoNumero" :maxlength="20" :disabled="pesquisaCodBarras"></b-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-form-group label="Código de Barras">
                    <input-codigoBarras v-model="model.codBarras"></input-codigoBarras>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="4">
                <b-form-group label="Espécie">
                    <input-select v-model="model.especie"
                                  :options="boletoEspecie"
                                  placeholder="Todos"
                                  :disabled="pesquisaCodBarras" />
                </b-form-group>
            </b-col>

            <b-col md="4">
                <b-form-group label="Modalidade">
                    <input-select v-model="model.modalidade"
                                  :options="boletoModalidade"
                                  placeholder="Todos"
                                  :disabled="pesquisaCodBarras" />
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="Situação">
                    <input-select v-model="situacaoBoletoValor"
                                  :options="situacaoBoleto"
                                  :disabled="apenasRegistrado || pesquisaCodBarras" />
                </b-form-group>
            </b-col>
        </b-row>

        <b-row v-if="mostrarFiltroDtPagamento">
          <b-col sm="3">
                <b-form-group label="Data Pagamento Início">
                    <input-date v-model="model.dtPagamentoInicio" :max="new Date()" :disabled="pesquisaCodBarras"></input-date>
                </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Data Pagamento Fim">
                  <input-date v-model="model.dtPagamentoFim" :max="new Date()" :min="model.dtPagamentoInicio" :disabled="pesquisaCodBarras"></input-date>
              </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { getDocumentMask } from '@/helpers/masks'

export default {
  props: {
    value: Object,
    apenasRegistrado: Boolean,
    loadGrid: Function,
    btnFunction: Function,
    btnTexto: String,
    btnDisabled: Boolean
  },
  data () {
    return {
      boletoModalidade: this.$api.Arrays.BoletoModalidade,
      boletoEspecie: this.$api.Arrays.BoletoEspecie,
      situacaoBoleto: this.$api.Arrays.SituacaoBoleto,
      cedentesCarteiras: [],
      codigoBoletoPrint: null,
      situacaoBoletoValor: null,
      mostrarFiltroDtPagamento: false
    }
  },
  computed: {
    documentMask () {
          const v = this.model.documentoPagador || null
          return getDocumentMask(v)
    },

    model: {
      get () {
        var obj = this.value
        if (!obj) { obj = {} }
        return obj
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    pesquisaCodBarras: {
      get () {
        return (this.model.codBarras ? this.model.codBarras !== '' : false)
      },
      set (value) {
        if (value) {
          this.model = {
            codBarras: this.model.codBarras,
            situacaoBoleto: this.situacaoBoleto.find(x => x.value == null),
            modalidade: this.boletoModalidade.find(x => x.value == null),
            especie: this.boletoEspecie.find(x => x.value == null)
          }
        }
      }
    }
  },
  watch: {
    situacaoBoletoValor: {
      handler(novoValor) {
        this.mostrarFiltroDtPagamento = novoValor.value == this.situacaoBoleto.find(x => x.text == 'Pago').value;
        this.$set(this.model, 'situacaoBoleto', novoValor)
      },
      deep: true,
    },
  },
  methods: {
    loadComboCedentesCarteiras (val) {
      if (val) {
        let th = this
        th.cedentesCarteiras = []
        th.model.codigoCedenteCarteira = {}
        th.$api.CedentesCarteiras.Combo(val).then(
          function (data) {
            if (Array.isArray(data) && data.length > 0) {
              let arrayCarteira = []
              data.forEach(function (item) {
                arrayCarteira.push({
                  value: item.guid,
                  text: item.string
                })
              })
              th.cedentesCarteiras = arrayCarteira
            } else {
              th.$api.UI.ShowError(
                'Erro',
                'Nao foram encontrados Carteiras relacionadas ao Cedente.'
              )
            }
          }
        )
      }
    },
    refresh () {
      this.$emit('refresh')
    }
  },
  mounted: function () {
    if (this.apenasRegistrado) {
      this.model.situacaoBoleto = this.situacaoBoleto.find(e => e.value === 2)
    } else {
      this.model.situacaoBoleto = this.situacaoBoleto.find(e => e.value === 1)
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      this.$refs.inputCedente.carregaCedentes()
    })
  }
}
</script>
